import axios from 'axios';

const getInitialState = function () {
  var state = {
    myMeetings: null,
  };
  return state;
};

export default {
  namespaced: true,

  state: getInitialState(),

  mutations: {
    SET_MY_MEETINGS: function (state, meetings) {
      state.myMeetings = meetings;
    },
    RESET_STATE:function (state) {
      Object.assign(state, getInitialState())
    }
  },

  actions: {
    loadMyMeetings: function ({ commit }) {
      axios.get('my-meetings').then(resp => {
        commit('SET_MY_MEETINGS', resp.data);
      });
    },
  },
};
